import React from 'react';
import { useTranslation } from 'react-i18next';
import { User, Building2 } from 'lucide-react';

/**
 * Step 1 · Profile type — two simple cards:
 *
 *   Privato                → stored as `individual`
 *   Azienda/Professionista → stored as `company`
 *
 * Legacy DB values (sole_proprietor, organization, freelancer,
 * association, other, persona_fisica, …) stay readable: they are
 * mapped onto the two cards without rewriting existing data.
 */
const CARDS = [
  { card: 'privato', value: 'individual', Icon: User },
  { card: 'azienda', value: 'company', Icon: Building2 },
];

const PRIVATO_VALUES = new Set(['individual', 'persona_fisica']);

export const subjectTypeToCard = (v) => {
  if (!v) return '';
  return PRIVATO_VALUES.has(v) ? 'individual' : 'company';
};

const StepTypeSelect = ({ value, onChange }) => {
  const { t } = useTranslation('onboarding');
  const selected = subjectTypeToCard(value);
  return (
    <div data-testid="wizard-step-type">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {CARDS.map(({ card, value: v, Icon }) => {
          const isSel = selected === v;
          return (
            <button
              type="button"
              key={card}
              onClick={() => onChange(v)}
              data-testid={`type-option-${card}`}
              className={`flex items-start gap-3 rounded-xl border p-4 text-left transition ${
                isSel
                  ? 'border-amber-400/70 bg-amber-500/10 shadow-[0_0_0_1px_rgba(251,191,36,0.35)]'
                  : 'border-white/10 bg-white/[0.02] hover:border-white/25'
              }`}
            >
              <div
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${
                  isSel ? 'bg-amber-500/25 gold-text' : 'bg-white/[0.05] text-muted-foreground'
                }`}
              >
                <Icon className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <p className={`text-sm font-semibold ${isSel ? 'gold-text' : 'text-foreground'}`}>
                  {t(`type_step.types.${card}.label`)}
                </p>
                <p className="mt-0.5 text-[12px] leading-relaxed text-muted-foreground">
                  {t(`type_step.types.${card}.desc`)}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StepTypeSelect;
